// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__sq9Ji","itemTitle":"ClientEmergencyInfo_itemTitle__3TOGM","itemText":"ClientEmergencyInfo_itemText__278b9"};